<template>
  <v-app data-app="true">
    <router-view v-if="isRouterAlive"></router-view>
    <v-card>
      <v-snackbar style="color: #000000;" color="#fff" v-model="$store.state.layerState" :bottom="layer.y === 'bottom'"
        :left="layer.x === 'left'" :multi-line="layer.mode === 'multi-line'" :right="layer.x === 'right'" :timeout="layer.timeout"
        :top="layer.y === 'top'" :vertical="layer.mode === 'vertical'">
        {{ $store.state.layerMsg }}
        <v-btn color="#000" flat @click="$store.commit('layerColose',false)">Close</v-btn>
      </v-snackbar>
    </v-card>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        layer: {
          y: 'top',
          x: null,
          mode: 'multi-line',
          timeout: 2000,
        },
        isRouterAlive: true,
        ws: null,
        heartBox: null,
        network: null,

        isShow: false,

        dialogContent: {
          title: '',
          content: ''
        },

      }
    },
    created() {
      // 处理IOS上下拉出现白色问题
      // document.body.addEventListener('touchmove', (e) => {
      //   if (e._isScroller) return;
      //   e.preventDefault()
      // }, {
      //   passive: false
      // })
      // 初始化数据
      this.init()

      // 新增弹窗
      // this.onNewDialog()
    },
    activated() {
     // this.initBrower()
    },
    mounted() {
      let _this = this
      //网络状态
      var EventUtil = {
        addHandler: function(element, type, handler) {
          if (element.addEventListener) {
            element.addEventListener(type, handler, false);
          } else if (element.attachEvent) {
            element.attachEvent("on" + type, handler);
          } else {
            element["on" + type] = handler;
          }
        }
      };
      EventUtil.addHandler(window, "online", function() {
        _this.$store.commit('layer', '网络已连接，3秒后自动刷新重连')
        clearTimeout(_this.network)
        _this.network = setTimeout(function() {
          location.reload()
        }, 3000)
      });
      EventUtil.addHandler(window, "offline", function() {
        _this.$store.commit('layer', '网络不可用，请检查你的网络设置')
      });
    },
    destroyed() {
      let _this = this;
      clearTimeout(_this.network)
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function() {
          this.isRouterAlive = true
        })
      },
      init() { //长连接-建立

        this.get('api/index/socket_url', {}).then((res) => {
          console.log('长连接-建立中')
          this.ws = new WebSocket(res.data.url)
          this.ws.onopen = this.open
          this.ws.onerror = this.error
          this.ws.onclose = this.close
          this.ws.onmessage = this.message

          this.$store.commit('setWebsocketObj', this.ws)
        })
      },
      open() { //长连接-发送心跳包
        console.log('长连接-发送心跳包')
        let _this = this
        _this.heartBox = setInterval(function() {
          _this.$store.state.webscoketObj.send(JSON.stringify({
            action: 'heartbeat'
          }))
        }, 10000)
      },
      // 接收长连接
      message(e) {
        let _this = this
        let rs = JSON.parse(e.data)
        let data = rs.data
        if (rs.type == 'init') { //绑定cliend_id
          _this.setClientId(data.client_id)
        }
      },
      error() { //长连接-连接失败
        let _this = this
        this.$store.commit('layer', '行情获取中')
      },
      close() { //长连接-关闭
        //长连接断开后以下页面会受影响：'/indexPage'，'/detailed'，'/detailed/timeSharing'，'/detailed/kLine'，'/detailed/handicap'，'/detailed/transaction'
        console.log('长连接-关闭')
        let _this = this
        clearInterval(_this.heartBox)
        _this.init()
      },
      onClose() {
        this.isShow = false
      },
      onNewDialog() {
        this.get('api/futures/index', {}).then((res) => {
          if (res.code == 0) {
            if (res.data.popmsg && res.data.popmsg.length > 0) {
              this.dialogContent = res.data.popmsg
              this.isShow = true
            } else {
              return
            }
          }
          return
        })
      },

      initBrower(){
        document.body.addEventListener('touchmove', (e) => {
          if (e._isScroller) return;
          e.preventDefault()
        }, {
          passive: false
        })
        this.$nextTick(() => {

          let z_body = document.getElementsByClassName('z-body')[0]
          console.log(z_body);

          z_body.addEventListener('touchmove', (e) => {
            e._isScroller = true
          }, false)

          let z_footer = document.getElementsByClassName('z-footer')[0]
          console.log(z_footer);

          z_footer.addEventListener('touchmove', (e) => {
            e._isScroller = true
          }, false)

        })
      }

    }
  }
</script>
<style>

  /* 加载隐藏占位 */
  .mescroll-downwarp-reset {
    height: 0 !important;
  }

  .dark-color {
    color: #fff !important;
  }

  .bg-color {
    background: #3a495c !important;
  }

  .theme--dark.v-icon {
    color: #768da9;
  }


  /* 公共变量 */




  /* 白色字体 */
  .lightFontColor {
    color: $light-font-color;
  }

  /* 主要字体颜色 */
  .mainFontColor {
    color: $dark-font-color;
  }

  /* 省略1行,2行 */
  .ellipsis-1,
  .ellipsis-2,
  .ellipsis-3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

  }

  .ellipsis-1 {
    -webkit-line-clamp: 1;
  }

  .ellipsis-2 {
    -webkit-line-clamp: 2;
  }

  .ellipsis-3 {
    -webkit-line-clamp: 3;
  }

  /* 行布局 两端对齐 */
  .d-space-row {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  /* 列布局 两端对齐 */
  .d-space-column {
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  /* 行布局 居中对齐 */
  .d-center-row {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  /* 列布局 居中对齐 */
  .d-center-column {
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* 行布局 P均分 */
  .d-around-row {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  /* 列布局 两端对齐 */
  .d-around-column {
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  /* 上下 内边距 */
  .pad-top-bottom {
    box-sizing: border-box;
    padding: 20px 0;
  }

  /* 左右 内边距 */
  .pad-left-right {
    box-sizing: border-box;
    padding: 0 20px;
  }

  /* 四面 内边距 */
  .pad-all {
    box-sizing: border-box;
    padding: 20px;
  }

  /* 上下 外边距 */
  .margin-top-bottom {
    margin: 20px 0;
  }

  /* 左右 外边距 */
  .margin-left-right {
    margin: 0 20px;
  }

  /* 四面 外边距 */
  .margin-all {
    margin: 20px;
  }

  /* 行间距 */
  .dis-20 {
    width: 100%;
    height: 20px;
  }

  .dis-40 {
    width: 100%;
    height: 40px;
  }

  .dis-60 {
    width: 100%;
    height: 60px;
  }

  .dis-80 {
    width: 100%;
    height: 80px;
  }

  /* 背景色 */
  .bg-color {
    background: $bg-color;
  }

  /* 背景图片 */
  .max-bg {

    /*图像的平铺模式*/
    background-repeat: no-repeat;

    /*背景图像扩展至足够大（center、cover、100%等）*/
    background-size: 100% 100% !important;

    /*背景图像的起始位置（center、100%）*/
    background-position: 100% 100% !important;
  }

  /* hover中间往两边下划线过渡 */
  .underline {
    position: relative;

    &::after {
      content: "";
      width: 0;
      height: 5px;
      background: blue;
      position: absolute;
      top: 100%;
      left: 50%;
      transition: all .8s;
    }

    &:hover:after {
      left: 0%;
      width: 100%;
    }
  }

  .underline-title {
    position: relative;

    &:after {
      content: '';
      width: 0;
      height: 0;
      border-bottom: 4upx solid #e00f00;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      transition: .3s;
    }
  }

  .underline-title-active {
    &:after {
      width: 50%;
    }
  }

  .full-img {
    width: 100%;
    height: 100%;
  }

  .avatar-radius {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .border-bottom {
    width: 100%;
    height: 2upx;
    background: #6A7AAF;
    opacity: 0.2;
  }

  .my-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
  }

  .uni-tab-item {
    /* #ifndef APP-PLUS */
    display: inline-block;
    /* #endif */
    flex-wrap: nowrap;
    padding-left: 34rpx;
    padding-right: 34rpx;


    .uni-tab-item-title {
      box-sizing: border-box;
      padding-bottom: 10upx;
      font-size: 30rpx;
      height: 80rpx;
      line-height: 80rpx;
      flex-wrap: nowrap;
      /* #ifndef APP-PLUS */
      white-space: nowrap;
      /* #endif */
      position: relative;

      &:after {
        content: '';
        width: 0;
        height: 0;
        border-bottom: 6upx solid #FE2C55;
        border-radius: 6upx;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        transition: .3s;
      }
    }

    .width-30 {
      color: #fff !important;
      font-weight: bold;

      &:after {
        width: 30%;
      }

      .width-50 {
        color: #fff !important;
        font-weight: bold;

        &:after {
          width: 50%;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue